"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.HubHttpClient = exports.HubRpcServer = exports.HubNoopEventPublisher = exports.HubRpcEventPublisher = exports.HubNoopService = exports.HubRpcClient = exports.RoutingKeys = exports.ProcessedReturn = exports.ReturnFlags = exports.ProcessedReturnItem = exports.ExternalLineItem = exports.ItemReport = exports.QuestionData = exports.ProcessingAction = exports.AbandonUndeliverableParcelOrigin = void 0;
var error_1 = require("../error");
var hub = require("../hub/index");
var AbandonUndeliverableParcelOrigin;
(function (AbandonUndeliverableParcelOrigin) {
    AbandonUndeliverableParcelOrigin["Customer"] = "Customer";
    AbandonUndeliverableParcelOrigin["Scheduler"] = "Scheduler";
})(AbandonUndeliverableParcelOrigin = exports.AbandonUndeliverableParcelOrigin || (exports.AbandonUndeliverableParcelOrigin = {}));
var utils_1 = require("../../utils");
var ProcessingAction;
(function (ProcessingAction) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ProcessingAction"), ProcessingActionTypeMap);
    }
    ProcessingAction.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ProcessingAction"), ProcessingActionTypeMap));
    }
    ProcessingAction.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ProcessingAction"), ProcessingActionTypeMap);
    }
    ProcessingAction.fromValue = fromValue;
})(ProcessingAction = exports.ProcessingAction || (exports.ProcessingAction = {}));
var ProcessingActionTypeMap = {
    "ProcessingAction": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "value", js: "value", typ: "string" },
        { json: "question", js: "question", typ: "string" }
    ], false)
};
var QuestionData;
(function (QuestionData) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("QuestionData"), QuestionDataTypeMap);
    }
    QuestionData.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("QuestionData"), QuestionDataTypeMap));
    }
    QuestionData.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("QuestionData"), QuestionDataTypeMap);
    }
    QuestionData.fromValue = fromValue;
})(QuestionData = exports.QuestionData || (exports.QuestionData = {}));
var QuestionDataTypeMap = {
    "QuestionData": (0, utils_1.o)([
        { json: "processingActions", js: "processingActions", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                { json: "value", js: "value", typ: "string" },
                                { json: "question", js: "question", typ: "string" }] } },
                    null,
                    undefined,
                    []
                ]
            } }
    ], false)
};
var ItemReport;
(function (ItemReport) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ItemReport"), ItemReportTypeMap);
    }
    ItemReport.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ItemReport"), ItemReportTypeMap));
    }
    ItemReport.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ItemReport"), ItemReportTypeMap);
    }
    ItemReport.fromValue = fromValue;
})(ItemReport = exports.ItemReport || (exports.ItemReport = {}));
var ItemReportTypeMap = {
    "ItemReport": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "comment", js: "comment", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "createdAt", js: "createdAt", typ: Date },
        { json: "updatedAt", js: "updatedAt", typ: Date },
        { json: "questionData", js: "questionData", typ: { "props": [{ json: "processingActions", js: "processingActions", typ: {
                            unionMembers: [
                                { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                            { json: "value", js: "value", typ: "string" },
                                            { json: "question", js: "question", typ: "string" }] } },
                                null,
                                undefined,
                                []
                            ]
                        } }] } },
        { json: "annotations", js: "annotations", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "canBeSoldAgain", js: "canBeSoldAgain", typ: "boolean" },
        { json: "returnApproved", js: "returnApproved", typ: "boolean" }
    ], false)
};
var ExternalLineItem;
(function (ExternalLineItem) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ExternalLineItem"), ExternalLineItemTypeMap);
    }
    ExternalLineItem.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ExternalLineItem"), ExternalLineItemTypeMap));
    }
    ExternalLineItem.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ExternalLineItem"), ExternalLineItemTypeMap);
    }
    ExternalLineItem.fromValue = fromValue;
})(ExternalLineItem = exports.ExternalLineItem || (exports.ExternalLineItem = {}));
var ExternalLineItemTypeMap = {
    "ExternalLineItem": (0, utils_1.o)([
        { json: "quantity", js: "quantity", typ: "number" },
        { json: "productId", js: "productId", typ: "string" },
        { json: "variantId", js: "variantId", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "orderItemId", js: "orderItemId", typ: "string" }
    ], false)
};
var ProcessedReturnItem;
(function (ProcessedReturnItem) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ProcessedReturnItem"), ProcessedReturnItemTypeMap);
    }
    ProcessedReturnItem.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ProcessedReturnItem"), ProcessedReturnItemTypeMap));
    }
    ProcessedReturnItem.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ProcessedReturnItem"), ProcessedReturnItemTypeMap);
    }
    ProcessedReturnItem.fromValue = fromValue;
})(ProcessedReturnItem = exports.ProcessedReturnItem || (exports.ProcessedReturnItem = {}));
var ProcessedReturnItemTypeMap = {
    "ProcessedReturnItem": (0, utils_1.o)([
        { json: "itemReport", js: "itemReport", typ: {
                unionMembers: [
                    {
                        props: [{ json: "id", js: "id", typ: "string" },
                            { json: "comment", js: "comment", typ: {
                                    unionMembers: [
                                        "string",
                                        null,
                                        undefined
                                    ]
                                } },
                            { json: "createdAt", js: "createdAt", typ: Date },
                            { json: "updatedAt", js: "updatedAt", typ: Date },
                            { json: "questionData", js: "questionData", typ: { "props": [{ json: "processingActions", js: "processingActions", typ: {
                                                unionMembers: [
                                                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                                                { json: "value", js: "value", typ: "string" },
                                                                { json: "question", js: "question", typ: "string" }] } },
                                                    null,
                                                    undefined,
                                                    []
                                                ]
                                            } }] } },
                            { json: "annotations", js: "annotations", typ: {
                                    unionMembers: [
                                        { arrayItems: "string" },
                                        null,
                                        undefined,
                                        []
                                    ]
                                } },
                            { json: "canBeSoldAgain", js: "canBeSoldAgain", typ: "boolean" },
                            { json: "returnApproved", js: "returnApproved", typ: "boolean" }]
                    },
                    null,
                    undefined
                ]
            } },
        { json: "orderItemId", js: "orderItemId", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var ReturnFlags;
(function (ReturnFlags) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ReturnFlags"), ReturnFlagsTypeMap);
    }
    ReturnFlags.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ReturnFlags"), ReturnFlagsTypeMap));
    }
    ReturnFlags.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ReturnFlags"), ReturnFlagsTypeMap);
    }
    ReturnFlags.fromValue = fromValue;
})(ReturnFlags = exports.ReturnFlags || (exports.ReturnFlags = {}));
var ReturnFlagsTypeMap = {
    "ReturnFlags": (0, utils_1.o)([
        { json: "hasRejectedItems", js: "hasRejectedItems", typ: "boolean" },
        { json: "hasMissingItems", js: "hasMissingItems", typ: "boolean" },
        { json: "hasSuperflousItems", js: "hasSuperflousItems", typ: "boolean" },
        { json: "hasUnexpectedItems", js: "hasUnexpectedItems", typ: "boolean" },
        { json: "isStraightForward", js: "isStraightForward", typ: "boolean" }
    ], false)
};
var ProcessedReturn;
(function (ProcessedReturn) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ProcessedReturn"), ProcessedReturnTypeMap);
    }
    ProcessedReturn.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ProcessedReturn"), ProcessedReturnTypeMap));
    }
    ProcessedReturn.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ProcessedReturn"), ProcessedReturnTypeMap);
    }
    ProcessedReturn.fromValue = fromValue;
})(ProcessedReturn = exports.ProcessedReturn || (exports.ProcessedReturn = {}));
var ProcessedReturnTypeMap = {
    "ProcessedReturn": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "orderId", js: "orderId", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "missing", js: "missing", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "quantity", js: "quantity", typ: "number" },
                                { json: "productId", js: "productId", typ: "string" },
                                { json: "variantId", js: "variantId", typ: {
                                        unionMembers: [
                                            "string",
                                            null,
                                            undefined
                                        ]
                                    } },
                                { json: "orderItemId", js: "orderItemId", typ: "string" }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "superfluous", js: "superfluous", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "quantity", js: "quantity", typ: "number" },
                                { json: "productId", js: "productId", typ: "string" },
                                { json: "variantId", js: "variantId", typ: {
                                        unionMembers: [
                                            "string",
                                            null,
                                            undefined
                                        ]
                                    } },
                                { json: "orderItemId", js: "orderItemId", typ: "string" }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "items", js: "items", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "itemReport", js: "itemReport", typ: {
                                        unionMembers: [
                                            {
                                                props: [{ json: "id", js: "id", typ: "string" },
                                                    { json: "comment", js: "comment", typ: {
                                                            unionMembers: [
                                                                "string",
                                                                null,
                                                                undefined
                                                            ]
                                                        } },
                                                    { json: "createdAt", js: "createdAt", typ: Date },
                                                    { json: "updatedAt", js: "updatedAt", typ: Date },
                                                    { json: "questionData", js: "questionData", typ: { "props": [{ json: "processingActions", js: "processingActions", typ: {
                                                                        unionMembers: [
                                                                            { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                                                                        { json: "value", js: "value", typ: "string" },
                                                                                        { json: "question", js: "question", typ: "string" }] } },
                                                                            null,
                                                                            undefined,
                                                                            []
                                                                        ]
                                                                    } }] } },
                                                    { json: "annotations", js: "annotations", typ: {
                                                            unionMembers: [
                                                                { arrayItems: "string" },
                                                                null,
                                                                undefined,
                                                                []
                                                            ]
                                                        } },
                                                    { json: "canBeSoldAgain", js: "canBeSoldAgain", typ: "boolean" },
                                                    { json: "returnApproved", js: "returnApproved", typ: "boolean" }]
                                            },
                                            null,
                                            undefined
                                        ]
                                    } },
                                { json: "orderItemId", js: "orderItemId", typ: {
                                        unionMembers: [
                                            "string",
                                            null,
                                            undefined
                                        ]
                                    } }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "flags", js: "flags", typ: { "props": [{ json: "hasRejectedItems", js: "hasRejectedItems", typ: "boolean" },
                    { json: "hasMissingItems", js: "hasMissingItems", typ: "boolean" },
                    { json: "hasSuperflousItems", js: "hasSuperflousItems", typ: "boolean" },
                    { json: "hasUnexpectedItems", js: "hasUnexpectedItems", typ: "boolean" },
                    { json: "isStraightForward", js: "isStraightForward", typ: "boolean" }] } }
    ], false)
};
(function (AbandonUndeliverableParcelOrigin) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("AbandonUndeliverableParcelOrigin"), AbandonUndeliverableParcelOriginTypeMap);
    }
    AbandonUndeliverableParcelOrigin.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("AbandonUndeliverableParcelOrigin"), AbandonUndeliverableParcelOriginTypeMap));
    }
    AbandonUndeliverableParcelOrigin.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("AbandonUndeliverableParcelOrigin"), AbandonUndeliverableParcelOriginTypeMap);
    }
    AbandonUndeliverableParcelOrigin.fromValue = fromValue;
})(AbandonUndeliverableParcelOrigin = exports.AbandonUndeliverableParcelOrigin || (exports.AbandonUndeliverableParcelOrigin = {}));
var AbandonUndeliverableParcelOriginTypeMap = {
    "AbandonUndeliverableParcelOrigin": ["Customer", "Scheduler"]
};
var RoutingKeys;
(function (RoutingKeys) {
    RoutingKeys["RedeliverParcel"] = "com.droppa.hub.redeliverParcel";
    RoutingKeys["AbandonUndeliverableParcel"] = "com.droppa.hub.abandonUndeliverableParcel";
    RoutingKeys["ReturnProcessingCompleted"] = "com.droppa.hub.returnProcessingCompleted";
    RoutingKeys["ParcelReceived"] = "com.droppa.hub.parcelReceived";
    RoutingKeys["ReturnReport"] = "com.droppa.hub.returnReport";
})(RoutingKeys = exports.RoutingKeys || (exports.RoutingKeys = {}));
(function (RoutingKeys) {
    RoutingKeys.All = [RoutingKeys.RedeliverParcel, RoutingKeys.AbandonUndeliverableParcel, RoutingKeys.ReturnProcessingCompleted, RoutingKeys.ParcelReceived, RoutingKeys.ReturnReport];
    function from(value) {
        var routingKey = RoutingKeys.All.find(function (x) { return x.toString() === value; });
        if (routingKey != undefined) {
            return routingKey;
        }
        throw new Error("Unknown routing key: ".concat(value));
    }
    RoutingKeys.from = from;
})(RoutingKeys = exports.RoutingKeys || (exports.RoutingKeys = {}));
var HubRpcClient = /** @class */ (function () {
    function HubRpcClient(client) {
        this.client = client;
    }
    HubRpcClient.prototype.redeliverParcel = function (undeliverableParcelId, shipmentId) {
        var request = { undeliverableParcelId: undeliverableParcelId, shipmentId: shipmentId };
        return this.client.broadcast(RoutingKeys.RedeliverParcel, request);
    };
    HubRpcClient.prototype.abandonUndeliverableParcel = function (undeliverableParcelId, origin) {
        var request = { undeliverableParcelId: undeliverableParcelId, origin: origin };
        return this.client.broadcast(RoutingKeys.AbandonUndeliverableParcel, request);
    };
    HubRpcClient.prototype.returnReport = function (shipmentIds) {
        var request = { shipmentIds: shipmentIds };
        return this.client.request(RoutingKeys.ReturnReport, request);
    };
    return HubRpcClient;
}());
exports.HubRpcClient = HubRpcClient;
var HubNoopService = /** @class */ (function () {
    function HubNoopService() {
    }
    /**
     * Event informing hub that customer requested a parcel to be redelivered.
     *
     * A ZPL shipment label has been created and can be requested via
     * shipments.lookUpMailShipment().
     */
    HubNoopService.prototype.redeliverParcel = function (undeliverableParcelId, shipmentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    /**
     * Event informing hub that the parcel should not be redelivered. The parcel
     * either expired or the customer decided not to have it redelivered.
     */
    HubNoopService.prototype.abandonUndeliverableParcel = function (undeliverableParcelId, origin) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    HubNoopService.prototype.returnReport = function (shipmentIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("HubNoopService.returnReport() not implemented");
            });
        });
    };
    return HubNoopService;
}());
exports.HubNoopService = HubNoopService;
var HubRpcEventPublisher = /** @class */ (function () {
    function HubRpcEventPublisher(client) {
        this.client = client;
    }
    HubRpcEventPublisher.prototype.returnProcessingCompleted = function (id, isStraightForward) {
        var request = { id: id, isStraightForward: isStraightForward };
        return this.client.broadcast(RoutingKeys.ReturnProcessingCompleted, request);
    };
    HubRpcEventPublisher.prototype.parcelReceived = function (shipmentId /* UUID */, barcode) {
        var request = { shipmentId: shipmentId, barcode: barcode };
        return this.client.broadcast(RoutingKeys.ParcelReceived, request);
    };
    return HubRpcEventPublisher;
}());
exports.HubRpcEventPublisher = HubRpcEventPublisher;
var HubNoopEventPublisher = /** @class */ (function () {
    function HubNoopEventPublisher() {
    }
    HubNoopEventPublisher.prototype.returnProcessingCompleted = function (id, isStraightForward) {
        return new Promise(function (resolve, reject) { return resolve(null); });
    };
    HubNoopEventPublisher.prototype.parcelReceived = function (shipmentId /* UUID */, barcode) {
        return new Promise(function (resolve, reject) { return resolve(null); });
    };
    return HubNoopEventPublisher;
}());
exports.HubNoopEventPublisher = HubNoopEventPublisher;
var HubRpcServer = /** @class */ (function () {
    function HubRpcServer(service) {
        this.service = service;
        this.handlerMapCached = this.generateHandlerMap();
    }
    HubRpcServer.prototype.handle = function (routingKey, body) {
        var method = this.handlerMapCached[routingKey];
        if (method == null) {
            throw new Error("Unknown routing key ".concat(routingKey));
        }
        return method(body);
    };
    HubRpcServer.prototype.handlerMap = function () { return this.handlerMapCached; };
    HubRpcServer.prototype.generateHandlerMap = function () {
        var _a;
        return _a = {},
            _a[RoutingKeys.RedeliverParcel] = this.redeliverParcel.bind(this),
            _a[RoutingKeys.AbandonUndeliverableParcel] = this.abandonUndeliverableParcel.bind(this),
            _a[RoutingKeys.ReturnReport] = this.returnReport.bind(this),
            _a;
    };
    HubRpcServer.prototype.routingKeys = function () {
        return [RoutingKeys.RedeliverParcel.toString(), RoutingKeys.AbandonUndeliverableParcel.toString(), RoutingKeys.ReturnReport.toString()];
    };
    HubRpcServer.prototype.redeliverParcel = function (_a) {
        var undeliverableParcelId = _a.undeliverableParcelId, shipmentId = _a.shipmentId;
        return this.service.redeliverParcel(undeliverableParcelId, shipmentId);
    };
    HubRpcServer.prototype.abandonUndeliverableParcel = function (_a) {
        var undeliverableParcelId = _a.undeliverableParcelId, origin = _a.origin;
        return this.service.abandonUndeliverableParcel(undeliverableParcelId, origin);
    };
    HubRpcServer.prototype.returnReport = function (_a) {
        var shipmentIds = _a.shipmentIds;
        return this.service.returnReport(shipmentIds);
    };
    return HubRpcServer;
}());
exports.HubRpcServer = HubRpcServer;
var HubHttpClient = /** @class */ (function () {
    function HubHttpClient(client) {
        this.client = client;
    }
    HubHttpClient.prototype.redeliverParcel = function (undeliverableParcelId, shipmentId) {
        var request = { undeliverableParcelId: undeliverableParcelId, shipmentId: shipmentId };
        return this.client.call("hub", "redeliverParcel", request).then(function (result) {
            if (result === null) {
                return result;
            }
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    HubHttpClient.prototype.abandonUndeliverableParcel = function (undeliverableParcelId, origin) {
        var request = { undeliverableParcelId: undeliverableParcelId, origin: origin };
        return this.client.call("hub", "abandonUndeliverableParcel", request).then(function (result) {
            if (result === null) {
                return result;
            }
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    HubHttpClient.prototype.returnReport = function (shipmentIds) {
        var request = { shipmentIds: shipmentIds };
        return this.client.call("hub", "returnReport", request).then(function (result) {
            if (typeof result === "object" && result !== null) {
                Object.values(result).every(function (r) { return hub.ProcessedReturn.fromValue(r); });
                return result;
            }
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    return HubHttpClient;
}());
exports.HubHttpClient = HubHttpClient;
//# sourceMappingURL=index.js.map